export default __webpack_public_path__ + "static/media/email.e5fb1e9e.svg";